import commonMixin from './../mixins/_common';
import flashMessageMixin from './../mixins/_flash_messages';
import paging from './_paging';
import categoryList from '../components/category/_category_list';
import imageSearch from './_image_search';

export default {
    template: '#storecreator_image_select_template',
    data() {
        return {
            // ストアクリエイターの画像リスト
            image_list: [],
            // 総ページ数
            pages: 0,
            // 現在のページ番号
            current_page: 1,
            // 画像検索モード
            mode: this.image_mode,
            // 絞り込みキー (pagekey or directory)
            filter_key: null,
            // 絞り込みキーの日本語名 (商品カテゴリの日本語化用)
            filter_name: '',
            // 追加画像ディレクトリ
            lib_directories: [],
            // カテゴリリスト
            categories: [],
            // 現在の開いている子カテゴリリスト [{page_key:, parent_page_key:}]
            show_childs: [],
            // 検索キーワード
            search_word: null,
        };
    },
    props: {
        // 初期の検索モード item|lib
        image_mode: {
            type: String,
            required: false,
            default: 'lib'
        },
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
    ],
    components: {
        // ページング
        'paging': paging,
        // カテゴリリスト
        'category-list': categoryList,
        // キーワード検索
        'image-search': imageSearch,
    },
    computed: {
        // 画像が取得されているか
        hasImages: function () {
            return (this.image_list.length > 0);
        },
    },
    created: function () {
        // JSで使う用にレンダリングされたJSON文字列をデータとして取得
        const data = document.querySelector('[data-roll="storecreator_data"]');
        if (!data) {
            return;
        }
        const storecreatorData = JSON.parse(data.innerHTML);
        // 商品画像カテゴリを取得
        if(storecreatorData) {
            this.categories = storecreatorData['categories'];
        }
    },
    emits: [
        'image-list-select',
    ],
    methods: {
        // ストアクリエイターもしくは商品画像検索から画像リストを取得
        getImageList: async function (currentPage, mode = null, filterKey = null, searchWord = null) {
            this.filter_name = ''; //初期化
            this.mode = (mode === null) ? this.mode : mode;
            this.filter_key = filterKey;
            this.search_word = searchWord;
            console.log('getImageList:' + this.mode);
            let success = true;
            this.$_loading();

            let params = {
                mode: this.mode,
                page: currentPage,
            };
            // 絞り込みキーが設定されている場合、追加する
            if(filterKey) {
                params['filter_key'] = filterKey;
            }
            // 検索キーワードが設定されている場合、追加する
            if (searchWord) {
                params['search_word'] = searchWord;
            }

            await axios.get('/get_images', {
                params
            })
                .then((response) => {
                // 取得後更新
                    this.current_page = currentPage;
                    // 検索結果を画面に反映する
                    this.image_list = response.data.data.images;
                    // ページ数
                    this.pages = response.data.data.pageCount;
                })
                .catch((error) => {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: this.getCatchMessage(error),
                    }, this.$parent);
                    success = false;
                });
            this.$_unloading();

            // 選択したフォルダの日本語をセット
            if (this.filter_key) {
                this.filter_name = (this.mode === 'lib') ? this.filter_key : this.getCategoryName(this.filter_key);
            }
            return success;
        },
        // 追加画像ディレクトリを取得する
        getLibDirectoryList: async function () {
            let success = true;
            try {
                this.$_loading();
                const response = await axios.get('/get_lib_directory_list');
                if (response.data.status === 'OK') {
                    this.lib_directories = response.data.data.directories;
                }
            } catch (e) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: this.getCatchMessage(e),
                }, this.$parent);
                success = false;
            } finally {
                this.$_unloading();
            }
            return success;
        },
        // 商品カテゴリのpage_keyから日本語名を取得
        getCategoryName: function (page_key) {
            const category = this.categories.find(category => category['page_key'] === page_key);
            return category['name'];
        },

        // -------------------------
        // emit
        // -------------------------

        // 画像管理からの選択
        emitImageListSelect: function (url) {
            this.$emit('image-list-select', url);
        },
    }
};
